import React, {useState} from "react"
import { useSelector } from "react-redux"
import PackageCard from "../PackageCard/PackageCard"
import packagesStyles from "./Packages.module.css"
import Carousel from "react-multi-carousel"
import { CarouselCustomLeftArrow, CarouselCustomRightArrow } from "../../../SearchAccordion/CarouselCustomArrows/CarouselCustomArrows"
import FooterForm from "../../../Footer/FooterForm"

const PopularPackages = ({ handleAccordionClose, handleAddressModalOpen }) => {
  const city = useSelector((state) => state.cityOnTopNav.citySelect);

  const packageAddedInCart = () => {

  }

  const popularPackages = [
    {
      packageName: "MRI CHEST",
      // price: 7000,
      // offer_price: 3900,
      slug: 'mri-chest',
      isAddedInCart: false,
    },
    {
      packageName: "X-RAY SINGLE KNEE AP/LAT",
      // price: 1499,
      // offer_price: 699,
      slug: 'x-ray-single-knee-ap-lat',
      isAddedInCart: false,
    },
    {
      packageName: "MRI BRAIN",
      // price: 160,
      // offer_price: 400,
      slug: 'mri-brain',
      isAddedInCart: false,
    },
    {
      packageName: "USG LOWER ABDOMEN",
      // price: 3599,
      // offer_price: 1199,
      slug: 'usg-lower-abdomen',
      isAddedInCart: false,
    },
  ];

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };

  const handleBookNow = () => {
    onOpenModal();
  };
  const [open, setOpen] = useState(false);

  const onOpenModal = () => {
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(false)
  }

  return (
    <>
    <div className={packagesStyles.container}>
      <p className={packagesStyles.heading}>Popular Package</p>
      <Carousel
        swipeable={true}
        draggable={false}
        showDots={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2500}
        transitionDuration={200}
        deviceType={"desktop"}
        containerClass={packagesStyles.carouselContainer}
        customLeftArrow={<CarouselCustomLeftArrow />}
        customRightArrow={<CarouselCustomRightArrow />}
        partialVisbile={true}
      >
        {popularPackages.map((packageCardData, index) => {
          return (
            <div key={index}>
              <PackageCard
                name={packageCardData.packageName}
                // price={packageCardData.price}
                // offerPrice={packageCardData.offer_price}
                slug={packageCardData.slug}
                isAddedInCart={packageCardData.isAddedInCart}
                handleAccordionClose={handleAccordionClose}
                handleAddressModalOpen={handleAddressModalOpen}
                onOpenModal={onOpenModal}
              />
            </div>
          );
        })}
      </Carousel>
    </div>
    {open && <FooterForm close={onCloseModal} />}
    </>
  );
};

export default PopularPackages;
